'use es6';

import { GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { HAS_USED_HUBSPOT } from '../constants/queryParamConstants';
import { EXPERIENCE_HAS_USED_CRM_PARAM, EXPERIENCE_NONE_PARAM, SALES_REP_ROLE, SURVEY_KEYS, GENERAL_OVERVIEW_HUB_INTEREST } from '../constants/surveyConstants';
import { createSalesGroupKey, createSalesOnboardingKey, getSalesInexperiencedGroupKey } from '../utils/onboardingKeyUtils';
import { HubletUrl } from '../utils/urls';
const suiteExperiencesChecks = [{
  redirectPath: (portalId, auth, survey) => {
    const salesOnboardingKey = createSalesOnboardingKey(survey[SURVEY_KEYS.JOB_ROLE], survey[SURVEY_KEYS.CRM_EXPERIENCE]);
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: salesOnboardingKey,
      groupKey: GROUP_KEYS.experiencedSalesIc
    };
  },
  checks: [{
    survey: {
      crmExperience: HAS_USED_HUBSPOT,
      hubInterest: [GENERAL_OVERVIEW_HUB_INTEREST],
      jobRole: SALES_REP_ROLE
    }
  }]
}, {
  redirectPath: (portalId, auth, survey) => {
    const salesOnboardingKey = createSalesOnboardingKey(survey[SURVEY_KEYS.JOB_ROLE], survey[SURVEY_KEYS.CRM_EXPERIENCE]);
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: salesOnboardingKey,
      groupKey: GROUP_KEYS.experiencedSalesLeader
    };
  },
  checks: [{
    survey: {
      crmExperience: HAS_USED_HUBSPOT,
      hubInterest: [GENERAL_OVERVIEW_HUB_INTEREST]
    }
  }]
}, {
  redirectPath: (portalId, auth, survey) => {
    const salesOnboardingKey = createSalesOnboardingKey(survey[SURVEY_KEYS.JOB_ROLE], survey[SURVEY_KEYS.CRM_EXPERIENCE]);
    const salesInexperiencedGroupKey = getSalesInexperiencedGroupKey(survey[SURVEY_KEYS.JOB_ROLE]);
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboarding: salesOnboardingKey,
      groupKey: salesInexperiencedGroupKey
    };
  },
  redirectParams: {
    variant: 'new-gs'
  },
  checks: [{
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      hubInterest: [GENERAL_OVERVIEW_HUB_INTEREST]
    }
  }]
}, {
  redirectPath: (portalId, auth, survey) => {
    const jobRole = survey[SURVEY_KEYS.JOB_ROLE];
    const crmExperience = survey[SURVEY_KEYS.CRM_EXPERIENCE];
    const salesOnboardingKey = createSalesOnboardingKey(jobRole, crmExperience);
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: salesOnboardingKey,
      groupKey: createSalesGroupKey(jobRole, crmExperience)
    };
  },
  redirectParams: {
    variant: 'new-gs'
  },
  checks: [{
    survey: {
      crmExperience: EXPERIENCE_HAS_USED_CRM_PARAM,
      hubInterest: [GENERAL_OVERVIEW_HUB_INTEREST]
    }
  }]
}];
export default suiteExperiencesChecks;